// Copyright (c) 2026 Cordchat. All Rights Reserved.
//
// +++ Cordchat - recovered from the 2024 production bundle (patched mattermost-redux reducers/entities/users).
// The patched package kept a second map `entities.users.statusesDetail` holding the *whole* status
// object of each user (status, manual, last_activity_at, ...). The upstream package only keeps the
// status string in `entities.users.statuses`. This wrapper adds the field back on top of the upstream
// entities reducer, so the stock mattermost-redux package can be used unmodified.

import {UserTypes} from 'mattermost-redux/action_types';
import upstreamEntities from 'mattermost-redux/reducers/entities';

function statusesDetail(state = {}, action) {
    switch (action.type) {
    case UserTypes.RECEIVED_STATUS: {
        const nextState = {...state};
        nextState[action.data.user_id] = action.data;
        return nextState;
    }
    case UserTypes.RECEIVED_STATUSES: {
        const nextState = {...state};
        for (const status of action.data) {
            nextState[status.user_id] = status;
        }
        return nextState;
    }
    case UserTypes.LOGOUT_SUCCESS:
        return {};
    default:
        return state;
    }
}

export default function entities(state, action) {
    const next = upstreamEntities(state, action);

    const prevDetail = state && state.users ? state.users.statusesDetail : {};
    const nextDetail = statusesDetail(prevDetail, action);

    if (next === state && nextDetail === prevDetail) {
        return state;
    }

    if (next.users !== (state && state.users) || nextDetail !== prevDetail || !next.users.statusesDetail) {
        return {
            ...next,
            users: {
                ...next.users,
                statusesDetail: nextDetail
            }
        };
    }

    return next;
}

// ---



// WEBPACK FOOTER //
// ./reducers/entities.js